import { useEffect, useState } from "react";
import {
  DEFAULT_PUBLIC_SETTINGS,
  fetchPublicSettings,
  getCachedPublicSettings,
  subscribePublicSettings,
} from "@/services/siteSettingsService";
import type { PublicSiteSettings } from "@/types/site";

/**
 * Shared hook over the public site settings. Returns the cached values right
 * away (when warm) and re-renders whenever the settings are refreshed.
 */
export function usePublicSettings(): { settings: PublicSiteSettings; loaded: boolean } {
  const [settings, setSettings] = useState<PublicSiteSettings>(
    getCachedPublicSettings() ?? DEFAULT_PUBLIC_SETTINGS,
  );
  const [loaded, setLoaded] = useState<boolean>(getCachedPublicSettings() !== null);

  useEffect(() => {
    let active = true;
    fetchPublicSettings().then((next) => {
      if (active) {
        setSettings(next);
        setLoaded(true);
      }
    });
    const unsubscribe = subscribePublicSettings((next) => {
      if (active) {
        setSettings(next);
        setLoaded(true);
      }
    });
    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return { settings, loaded };
}